import React, { useEffect, useState } from 'react';
import { Radio } from '../../../../radio';
import styles from './radio-cell.module.scss';
export const RadioCell = ({ node, api, colDef, data, }) => {
    const cellData = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) ? data[colDef.colId] : {};
    const [isSelected, setIsSelected] = useState(node.isSelected());
    const onChangeHandler = () => {
        node.setSelected(true);
    };
    useEffect(() => {
        const listener = () => {
            const selectedNodes = api.getSelectedNodes();
            const isNodeSelected = selectedNodes[0].id === node.id;
            setIsSelected(isNodeSelected);
        };
        api.addEventListener('selectionChanged', listener);
        return () => {
            node.removeEventListener('selectionChanged', listener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement("div", { className: styles.cellContainer },
        React.createElement(Radio.Group, { onChange: onChangeHandler, selectedValue: isSelected ? node.id : '', className: styles.radioGroup }, [
            React.createElement(Radio, { id: node.id, value: node.id, key: node.id, label: cellData.label, hideLabel: true, className: styles.radioButton }),
        ])));
};
//# sourceMappingURL=radio-cell.js.map